import React from 'react';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {ROUTE_CHANGE_COLOR} from "@containers/singleVoyage/voyageTemplates/routeChange/routeChangeStyle";
import {sx} from './sx'

export type RouteChangeLegendItem =
	'newRoute'
	| 'oldRoute'
	| 'changedRoute'
	| 'added'
	| 'changed'
	| 'movedStop'
	| 'oldPosition'
	| 'removed'

const halo = (rgb: string) => ({bgcolor: `rgba(${rgb}, 0.3)`})
const ringWithHalo = (color: string, rgb: string) => ({
	border: `2px solid ${color}`,
	bgcolor: '#FFFFFF',
	boxShadow: `0 0 0 3px rgba(${rgb}, 0.3)`,
})

/** Each swatch draws the item the way the map does. */
const SWATCH: Record<RouteChangeLegendItem, object> = {
	newRoute: {...sx.line, bgcolor: ROUTE_CHANGE_COLOR.newRoute},
	oldRoute: {...sx.line, ...sx.lineWide, bgcolor: ROUTE_CHANGE_COLOR.oldRoute},
	changedRoute: {...sx.line, ...sx.lineDashed, borderColor: ROUTE_CHANGE_COLOR.changed},
	added: {...sx.dot, bgcolor: ROUTE_CHANGE_COLOR.added},
	changed: {...sx.dot, bgcolor: ROUTE_CHANGE_COLOR.changed},
	movedStop: {...sx.dot, ...sx.dotLarge, ...halo('224, 122, 16')},
	oldPosition: {...sx.dot, ...ringWithHalo(ROUTE_CHANGE_COLOR.oldRoute, '56, 168, 232')},
	removed: {...sx.dot, ...ringWithHalo(ROUTE_CHANGE_COLOR.removed, '226, 75, 74')},
}

interface IProps {
	items: RouteChangeLegendItem[]
	/** row: under a map; overlay: a panel in the map corner */
	variant: 'row' | 'overlay'
}

const RouteChangeLegend = ({items, variant}: IProps) => {

	const {t} = useTranslation()

	return (
		<Box sx={variant === 'overlay' ? sx.overlay : sx.row}>
			{items.map((item) => (
				<Box key={item} sx={sx.item}>
					<Box sx={SWATCH[item]}/>
					{t(`singleVoyage.voyageTemplate.sync.legend.${item}`)}
				</Box>
			))}
		</Box>
	);
};

export default RouteChangeLegend;
